export default __webpack_public_path__ + "static/media/credentials-active.192db1c0.svg";